<a href="javascript:;" class="m-nav__link m-dropdown__toggle" id="m_topbar_notification_icon_not" [ngClass]="{ 'm--hide': !this.showMenu }">
  <span class="m-nav__link-icon">
    <span class="m-nav__link-icon-wrapper">
      <i class="flaticon-settings-1"></i>
    </span>
  </span>
</a>
<div class="m-dropdown__wrapper">
  <span
    class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust m-dropdown__arrow-{{
      currentTheme.baseSettings.menu.asideSkin
    }}"
  ></span>
  <div class="m-dropdown__inner m-dropdown__inner-{{ currentTheme.baseSettings.menu.asideSkin }}">
    <div class="m-dropdown__body">
      <div class="m-dropdown__content">
        <ul class="m-nav m-nav--skin-{{ currentTheme.baseSettings.menu.asideSkin }}">
          <ng-container *ngFor="let menu of this.menu?.items">
            <li class="m-nav__item" *ngIf="showMenuItem(menu)">
              <a [routerLink]="menu.route" class="m-nav__link">
                <span class="m-nav__link-icon">
                  <span class="m-nav__link-icon-wrapper m-nav__link-text-{{ currentTheme.baseSettings.menu.asideSkin }}">
                    <i [class]="menu.icon"></i>
                  </span>
                </span>
                <span class="m-nav__link-title m-topbar__menu-text m-nav__link-text-{{ currentTheme.baseSettings.menu.asideSkin }}">
                  {{ menu.name | localize }}
                </span>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
